export enum TravelerInfoBlocks {
  FirstName = 'First name',
  MiddleName = 'Middle name',
  LastName = 'Last name',
  Gender = 'Gender',
  DateOfBirth = 'Date of birth:',
  Citizenship = 'Citizenship',
  PassportNumber = 'Passport number',
  ExpiryDate = 'Expiry date',
  PhoneNumber = 'Phone number',
  Email = 'Email',
  KnownTravelerNumber = 'Known traveler number',
  RedressNumber = 'Redress number',
  FrequentFlyerDetails = 'Frequent flyer details',
  ExecutiveClub = 'Executive Club',
}
